export const pointMap = new Map([
  ['未完善信息','complete info false'],
  ['成功完善信息','complete info'],
  ['设置机器人','set robot'],
  ['编辑机器人','edit robot',],
  ['删除机器人','delete robot',],
  ['新建机器人','create robot',],
  ['进入人工客服页','to platform',],
  ['进入工单中心页','to work order',],
  ['进入全局设置页','to all set'],
  ['进入账号详情页','to user info'],
  ['点击机器人', 'to set robot'],

  ['点击问答库','click rules'],
  ['点击未知问题','click unknownq'],
  ['点击素材管理','click material'],
  ['点击自定义词库','click word'],
  ['点击任务对话','click task'],
  ['点击技能管理','click robot-info'],
  ['点击自动应答','click response'],
  ['点击访客端设置','click clientSet'],
  ['点击转人工设置','click customerService'],
  ['点击网站','click web'],
  ['点击手机APP','click app'],
  ['点击企业微信','click wechat-company'],
  ['点击个人微信','click newWechat'],
  ['点击微信公众号','click wechat-public'],
  ['点击微信小程序','click wechat-program'],
  ['点击QQ','click qq'],
  ['点击微博','click weibo'],
  ['点击API','click api'],
  ['点击历史会话','click history'],
  ['点击访客统计','click visitor-statistics'],
  ['点击问答统计','click kb-statistics'],
  ['点击客服统计','click list'],

  ['进入添加问答页','to add rule'],
  ['成功添加问答规则','complete add rule'],
  ['点击添加分类','click add category'],
  ['成功添加分类','complete add category'],
  ['点击行业问答库','click industry'],
  ['成功导入行业问答库','complete import industry'],
  ['开启日常聊天','open freechat skills'],
  ['关闭日常聊天','close freechat skills'],
  ['开启物流查询','open logistics skills'],
  ['关闭物流查询','close logistics skills'],
  ['开启自动对联','open couplet skills'],
  ['关闭自动对联','close couplet skills'],
  ['开启机器写诗','open poetry skills'],
  ['关闭机器写诗','close poetry skills'],
  ['开启知识问答','open kb skills'],
  ['关闭知识问答','close kb skills'],
  ['点击机器人测试','click robot test'],
  ['关闭机器人测试','close robot test'],

  ['机器人测试发送消息','send message in robot test'],
  ['机器人测试触发问答库','trigger kb in robot test']
])






// WEBPACK FOOTER //
// ./services/pointMap.js